import { render, staticRenderFns } from "./Common.vue?vue&type=template&id=72bbd842&scoped=true"
import script from "./Common.vue?vue&type=script&lang=js"
export * from "./Common.vue?vue&type=script&lang=js"
import style0 from "./Common.vue?vue&type=style&index=0&id=72bbd842&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bbd842",
  null
  
)

export default component.exports